<template>

    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("subproductos") }}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambioNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-8 text-right" v-if="respuesta">
                            <label> </label><br>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <router-link :to="{ name: 'subproducto', params: { 'idBusiness': idBusiness } }">

                                    <!-- <button class="btn btn-primary" v-if="!businessCentral"><i class="fa fa-plus-square"></i>
                                        {{ $t("agregarSubproducto") }}
                                    </button> -->
                                    
                                     <button v-if="!restriccionBusinessCentral" class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                        {{ $t("agregarSubproducto") }}  
                                    </button>
                                </router-link>
                            </div>
                        </div>

                        <div class="col-md-3 text-right " >
                            <div style="margin-top: 4px;" class="form-group justify-content-center">
                                <el-checkbox class="form-group" v-model="isDeBaja" @change="changeIsDeBaja()">
                                    <strong>{{ $t("buscarSubProductoBaja") }}</strong>
                                </el-checkbox>
                            </div>
                        </div>



                        <div class="col-md-3 text-right">
                            <el-select class="select-default filterTag" size="large" v-model="filter" filterable
                                @change="cambioFiltro()" :placeholder="$t('seleccionaNegocio')">
                                <el-option v-for="filter in filterTag" class="select-primary" :value="filter.id"
                                    :label="filter.name" :key="filter.id">
                                </el-option>
                            </el-select>
                        </div>

                        <div class="col-md-3 text-right">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                    v-model="searchQuery" @keyup.enter.prevent="searchSubproductos">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchSubproductos"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{ showResult }}</small>
                            </p>
                        </div>
                    </div>

                    <div v-if="listSubproducts.length > 0">
                        <div class="table-responsive">

                            <table class="table table-bordered table-striped">

                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t("materiaPrima") }}</th>
                                        <th>{{ $t("descripcion") }}</th>
                                        <th>Código de barras</th>
                                        <th>{{ $t("etiqueta") }}</th>
                                        <th>{{ $t("tipo") }}</th>
                                        <th>{{ $t("escandallo") }}</th>
                                        <th>{{ $t("precioCompraSinIva") }}</th>
                                        <th>{{ $t("precioDto") }}</th>
                                        <th>{{ $t("precioCompraConIva") }}</th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in listSubproducts">
                                        <td>
                                            <div>{{ sub.name }}
                                                <span style="color: red" v-if="sub.baja == '1'">
                                                    [{{ $t("BAJA") }}]
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div>{{ sub.description }}</div>
                                        </td>
                                        <td>
                                            <div>{{ sub.barCode }}</div>
                                        </td>
                                        <td>
                                            <div v-if="sub.nombreCat">{{ sub.nombreCat }}</div>
                                            <div v-else>{{ $t("sinEtiqueta") }}</div>
                                        </td>
                                        <td>
                                            <div>{{ sub.type }}</div>
                                        </td>
                                        <td>
                                            <div>{{ parseInt(sub.escandallo) }}</div>
                                        </td>
                                        <td>
                                            <!-- <div>{{ parseFloat(sub.precio_compra / (1 + sub.iva / 100)) | currency }}</div> -->
                                            <div>{{ parseFloat(sub.precio_compra / (1 + sub.iva / 100)).toFixed(4) }} €</div>
                                        </td>

                                        <td>
                                            <template v-if="parseFloat(sub.dto_compra) !== 0">
                                                <div>{{ (parseFloat(sub.precio_compra / (1 + sub.iva / 100)) -
                                                        parseFloat(sub.precio_compra / (1 + sub.iva / 100)) * parseFloat((sub.dto_compra / 100)))
                                                        | currency
                                                }}</div>
                                            </template>
                                            <template v-else>
                                                <div>{{ '-' }}</div>
                                            </template>
                                        </td>

                                        <td>
                                            <!-- <div>{{ parseFloat(sub.precio_compra) | currency }}</div> -->
                                            <div>{{ parseFloat(sub.precio_compra).toFixed(4) }} €</div>
                                        </td>


                                        <td align="center">
                                            <router-link
                                                :to="{ name: 'subproducto', params: { 'idBusiness': idBusiness, 'filtro': filter,'SpProv' : SpProv, 'idSubproducto': sub.id, 'pag': pag } }">
                                                <a class="btn btn-danger btn-link btn-xs">
                                                    <i v-tooltip.top-center="$i18n.t('editar')"
                                                        class="fas fa-pencil-alt" style="color: orange"></i>
                                                </a>
                                            </router-link>
                                            <!-- Baja/alta rapida sin entrar en el formulario. Con BC la baja la manda BC, igual que en el formulario. -->
                                            <!-- Encendido (verde) = activo, apagado (rojo) = de baja. Refleja siempre sub.baja. -->
                                            <el-switch :value="sub.baja != '1'" @change="alternarBaja(sub)"
                                                :disabled="restriccionBusinessCentral || sub.cambiandoBaja"
                                                v-tooltip.top-center="sub.baja == '1' ? $i18n.t('baja') : $i18n.t('activo')"
                                                active-color="#13ce66" inactive-color="#ff4949" class="switch-baja">
                                            </el-switch>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{ $t("noHay") }} <strong>{{ $t("subproductosCreados") }}</strong> {{ $t("enEsteNegocio") }}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{ 'disabled': pag == 1 }">
                                        <router-link class="page-link"
                                            :to="{ name: 'subproductos', params: { pag: pag - 1 } }" v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                                        <router-link class="page-link" :to="{ name: 'subproductos', params: { pag: n } }">
                                            {{ n }}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{ 'disabled': pag == totalPags }">
                                        <router-link class="page-link"
                                            :to="{name: 'subproductos', params: {pag: nextPag}}"
                                            v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox, Switch } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {

    created() {
        //            this.loading = Loading.service({text: 'Cargando...'});
        this.$store.dispatch("setNameRoute", this.$i18n.t("subproductos"));
        this.getBusiness();
        this.tieneBusinessCentral();
        var filtro = this.$route.query.filtro;

        if (filtro != undefined) {
            this.filter = parseInt(filtro);
        }

        Promise.all([
            this.getCompanies(),
            // this.getCompanyConfigs()
        ]);

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        [Switch.name]: Switch
    },
    data() {
        return {

            //PRUEBAS INICIO PAGINA
            loadingGeneral: null,
            peticionesIniciales: 0,

            loading: false,
            listBusinesses: [],
            listCategory: ["-"],
            idBusiness: this.$route.params.idBusiness,
            searchQuery: this.$route.params.query,
            isSearch: false,
            pag: this.$route.params.pag,
            totalPags: 0,
            listSubproducts: ["-"],
            filterTag: [],
            filter: -1,
            baja: 0,
            isDeBaja: false,
            SpProv: 0,

            respuesta: true,

            //BUSINESS CENTRAL
            businessCentral: false,
            restriccionBusinessCentral : false,
            
            //CompanyConfigs
            companyConfigs: [],
            idCompany: 0,
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.pag) {
                this.pag = to.params.pag;
                this.getSubproducts();
            } else if (to.params.query) {
                this.query = to.params.query;
                this.getSubproducts();
            }
        }
    },
    computed: {
        ...mapState(["permiso"]),

        showResult() {
            if (this.listSubproducts.length == 0) {
                return this.$t('noEncontramosResultadosPara') + this.searchQuery;
            } else {
                const result = this.listSubproducts.length == 1 ? this.$t('resultado') : this.$t('resultados');
                return this.$t('mostrando') + " " + this.listSubproducts.length + " " + result;
            }
        },
        nextPag() {
            let nextPag = parseInt(this.pag) + 1;
            return nextPag;
        },
        urlExportPDF() {


            return this.$store.getters.apiUrl + "/subproducts/exportListSubproducts/PDF?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt


        },
        urlExportExcel() {


            /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
             */
            return this.$store.getters.apiUrl + "/subproducts/exportListSubproducts/Excel?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt
        }
    },
    updated() {

        this.peticionesIniciales++;

        if (this.peticionesIniciales === 3) {
            this.loadingGeneral.close();
        }

    },
    methods: {

        cambioNegocio() {
            this.pag = 1;
            this.totalPags = 0;
            this.filter = -1;
            this.getCategory()
            this.getSubproducts();

        },
        cambioFiltro() {


            this.pag = 1;
            this.totalPags = 0;
            this.getSubproducts();

        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    if (response.data.response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                        //                        vm.loading.close();
                        vm.getSubproducts();
                        vm.getCategory();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getCategory() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'subproducts/getCategoryByBusinesses', config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.filterTag = [];

                        if (response.data.result.length === 0) {

                            let category = {
                                name: vm.$t('todos'),
                                id: -1
                            };

                            vm.filterTag.push(category);

                        }

                        for (let i = 0; i < response.data.result.length; i++) {

                            if (i === 0) {

                                let category = {
                                    name: vm.$t('todos'),
                                    id: -1
                                };

                                vm.filterTag.push(category);

                            }


                            let categoryname = {
                                name: response.data.result[i].name,
                                id: response.data.result[i].id,
                            };

                            vm.filterTag.push(categoryname)

                        }

                        if (response.data.result.length > 0) {
                            vm.filterTag.push({
                                name: vm.$t('sinEtiqueta'),
                                id: 0,
                            });
                        }

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: this.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },

        getSubproducts() {

            const controller = this.searchQuery ? 'searchSubproductsByBusiness/' + this.searchQuery : 'getSubproductsByBusiness';
            var config = {
                params: {
                    pag: this.pag,
                    idBusiness: this.idBusiness,
                    filter: this.filter,
                    jwt: this.$store.getters.jwt,
                    baja: this.baja
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listSubproducts = response.data.result.listSubproduct;
                        vm.pag = response.data.result.pag;
                        vm.totalPags = response.data.result.totalPags;

                        vm.respuesta = true;

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: this.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        searchSubproductos() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({ name: 'search-subproductos', params: { query: this.searchQuery } });
                this.isSearch = true;
            }
        },
        removeSearch() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                this.isSearch = false;
                this.$router.push({ name: 'subproductos' });
                this.getSubproducts()
            }
        },

        changeIsDeBaja() {

            if (this.isDeBaja) {
                this.baja = 1
            } else {
                this.baja = 0
            }
            this.getSubproducts()

        },

        // Sin confirmacion: si lo pulsa es que quiere cambiarlo, y se deshace con otro clic.
        alternarBaja(sub) {
            this.cambiarBaja(sub, sub.baja == '1' ? 0 : 1);
        },

        cambiarBaja(sub, baja) {
            var config = {
                params: { jwt: this.$store.getters.jwt },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
                idBusiness: this.idBusiness,
                idSubproduct: sub.id,
                baja: baja,
                jwt: this.$store.getters.jwt,
            };

            this.$set(sub, "cambiandoBaja", true);
            let vm = this;
            this.axios
                .post(this.$store.getters.apiUrl + "subproducts/changeBajaSubproduct", params, config)
                .then(function (response) {
                    vm.$set(sub, "cambiandoBaja", false);

                    if (response.data.response) {
                        sub.baja = String(baja);
                        vm.$notify({
                            message: vm.$t("subproductoDeVerdad") + " " + vm.$t("actualizado") + " " + vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                        // La lista filtra por baja: se recarga para que la fila salga de esta vista
                        // (dar de baja la quita de activas; dar de alta la quita de "de baja").
                        vm.getSubproducts();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    vm.$set(sub, "cambiandoBaja", false);
                    console.log(error);
                    swal({
                        title: vm.$t("atencion"),
                        text: vm.$t("errorServidorDarDeBaja"),
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                });
        },

        tieneBusinessCentral() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getRestrictionsByUser",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        for (let i = 0; i < response.data.result.length; i++) {

                            switch (response.data.result[i].idRestriction) {
                                case "76":
                                    vm.businessCentral = true;
                                    break;
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

                getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                return this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;

                            vm.getCompanyConfigs();

                            // console.log("idCompany",vm.idCompany);
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
        },

        getCompanyConfigs() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idCompany: this.idCompany
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            }; 
            let vm = this;
            return this.axios
                .get(
                    this.$store.getters.apiUrl + "general/getCompanyConfigs",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.companyConfigs = response.data.result;

                        vm.companyConfigs.forEach(function (x) {
                            if (x.idConfig == "134") {
                                vm.restriccionBusinessCentral = true;
                            }
                        });


                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        }


    }

</script>

<style scoped>
tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
    cursor: pointer;
}

tbody td {
    padding: 0 !important;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}

.switch-baja {
    margin-left: 6px;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Subproductos/Subproductos.vue